import React, { useEffect, useState } from 'react';

export const CheckboxField = ({input}) => {
  const [ defVal, setDefVal ] = useState(input.value);

  useEffect(() => {
    if (input.defaultChecked !== undefined) {
      setDefVal(input.defaultChecked);

      if (!input.notEmitDefaultChecked) {
        input.onChange(input.defaultChecked);
      }
    }
  }, []);

  return (
    <div className="custom-checkbox">
      <input className="custom-checkbox__input" type="checkbox"
             id={input.name}
             checked={input.value === '' ? defVal : input.value}
             onChange={ev => input.onChange(ev.target.checked)}
      />
      <label htmlFor={input.name} className="custom-checkbox__label">
        {input.title && <span className="custom-checkbox__title">{input.title}</span>}
      </label>
    </div>
  );
};
